var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27638 16.1205C8.61835 16.1728 8.96858 16.1999 9.3252 16.1999C13.1221 16.1999 16.2002 13.1219 16.2002 9.32497C16.2002 5.52799 13.1221 2.44995 9.3252 2.44995C9.07046 2.44995 8.81892 2.46381 8.57138 2.49081C10.4549 3.91776 11.7002 6.38963 11.7002 9.19995C11.7002 12.1545 10.3238 14.735 8.27638 16.1205ZM9.20018 18.2C14.1707 18.2 18.2002 14.1705 18.2002 9.19995C18.2002 4.22938 14.1707 0.199951 9.20018 0.199951C4.22962 0.199951 0.200195 4.22938 0.200195 9.19995C0.200195 14.1705 4.22962 18.2 9.20018 18.2Z",
    fill: "#595761"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.8571f9cdb658b3fb3e6dafb5a1d9e2f6.svg";
export { ForwardRef as ReactComponent };